export enum NotificationTypeEnum {
    Success = "SUCCESS",
    Info = "INFO",
    Warning = "WARNING",
    Danger = "DANGER",
    Error = "ERROR"
}